/**
 * 依頼者追加可能書類 whitelist (19-D-E2/F1) の FE 定数
 *
 * BE `backend/lambdas/shared/requester-addable-documents.ts` と同期して同一値を保つ。
 */

/** whitelist option の上限 (無効 option も含む。BE MAX_REQUESTER_ADDABLE_OPTIONS と同値) */
export const MAX_REQUESTER_ADDABLE_OPTIONS = 20;

/** 書類名の最大文字数 (FE 側の入力ガード。BE は非空のみ必須) */
export const REQUESTER_ADDABLE_NAME_MAX_LENGTH = 60;

/** 説明の最大文字数 (FE 側の入力ガード) */
export const REQUESTER_ADDABLE_DESCRIPTION_MAX_LENGTH = 200;
